import { useSuspenseQuery } from "@tanstack/react-query";
import api from "apis";

const useUsersDetailQuery = (uuid: string) => {
  return useSuspenseQuery({
    queryKey: api.user.getUserByUuidKey(uuid),
    queryFn: () => api.user.getUserByUuid(uuid),
  });
};

export default useUsersDetailQuery;
